import { NavLink } from "react-router-dom";
import {
  House, ListChecks, ChatsCircle, Receipt, Gear,
} from "@phosphor-icons/react";
import { useNotifications } from "../context/NotificationsContext";

const items = [
  { to: "/recurring", label: "Monthly", icon: ListChecks, key: "monthly" },
  { to: "/payment-advices", label: "Remit", icon: Receipt, key: "remit" },
  { to: "/questions", label: "Inquiries", icon: ChatsCircle, key: "inquiries" },
  { to: "/close", label: "Close", icon: House, key: "close" },
  { to: "/settings", label: "More", icon: Gear, key: "more" },
];

export default function MobileNav() {
  const { unresolvedInquiries = 0 } = useNotifications() || {};

  return (
    <nav
      data-testid="mobile-nav"
      className="lg:hidden fixed bottom-0 left-0 right-0 bg-white border-t border-[#E5E5E5] z-30"
      style={{ paddingBottom: "env(safe-area-inset-bottom)" }}
    >
      <div className="grid grid-cols-5">
        {items.map(({ to, label, icon: Icon, end, key, inactive }) => {
          const isInquiries = key === "inquiries";
          const showRed = isInquiries && unresolvedInquiries > 0;
          return (
            <NavLink
              key={to}
              to={to}
              end={end}
              data-testid={`mobile-nav-${label.toLowerCase().replace(/[^a-z0-9]+/g, '-')}`}
              className={({ isActive }) =>
                `relative flex flex-col items-center gap-1 py-3 text-[9px] font-semibold tracking-[0.1em] uppercase transition-colors px-1 ${
                  showRed
                    ? "text-[#DC2626]"
                    : isActive
                      ? "text-[#002FA7]"
                      : inactive
                        ? "text-[#A3A3A3] italic"
                        : "text-[#525252]"
                }`
              }
            >
              <div className="relative">
                <Icon size={20} weight={showRed ? "fill" : "duotone"} />
                {showRed && (
                  <span
                    data-testid="mobile-inquiries-badge"
                    className="absolute -top-1.5 -right-2 min-w-[16px] h-[16px] px-1 bg-[#DC2626] text-white text-[9px] font-bold rounded-full flex items-center justify-center border border-white"
                  >
                    {unresolvedInquiries > 9 ? "9+" : unresolvedInquiries}
                  </span>
                )}
              </div>
              <span className="truncate max-w-full">{label}</span>
            </NavLink>
          );
        })}
      </div>
    </nav>
  );
}
